import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { T as Target } from './roche-text-link.types.js';
import { d as defineCustomElement$5 } from './roche-headline2.js';
import { d as defineCustomElement$4 } from './roche-icon2.js';
import { d as defineCustomElement$3 } from './roche-overline2.js';
import { d as defineCustomElement$2 } from './roche-text-link2.js';

const rocheBackToBranchCss = ":host{display:block;margin-top:3rem;border-top:1px solid #c2bab5}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .back-to-branch{margin-top:1rem}:host .back-to-branch>*{margin-top:0}@media (min-width: 64rem){:host .back-to-branch>*{margin-top:0}}:host .back-to-branch>:last-child{margin-top:1rem}@media print{:host{display:none}}";
const RocheBackToBranchStyle0 = rocheBackToBranchCss;

const RocheBackToBranch$1 = /*@__PURE__*/ proxyCustomElement(class RocheBackToBranch extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.overlineText = undefined;
        this.level = 5;
        this.headline = undefined;
        this.linkText = undefined;
        this.href = undefined;
        this.target = Target.SELF;
        this.icon = undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h("div", { key: '27518ffb803ddf59678e1b8a02fb9e5d40d1aa13', class: 'back-to-branch' }, this.overlineText
            && h("roche-overline", { overlineText: this.overlineText }), h("roche-headline", { key: '5c13f4ce4b9de2cfd36e3772e1f97d3e9d0ba9b8', headline: this.headline, level: this.level }), h("roche-text-link", { key: '19001267881fc3ca59ad9e15a315ccb28d813034', href: this.href, "right-icon": this.icon, target: this.target, text: this.linkText })));
    }
    static get style() { return RocheBackToBranchStyle0; }
}, [1, "roche-back-to-branch", {
        "overlineText": [1, "overline-text"],
        "level": [2],
        "headline": [1],
        "linkText": [1, "link-text"],
        "href": [1],
        "target": [1],
        "icon": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-back-to-branch", "roche-headline", "roche-icon", "roche-overline", "roche-text-link"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-back-to-branch":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheBackToBranch$1);
            }
            break;
        case "roche-headline":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-overline":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-text-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheBackToBranch = RocheBackToBranch$1;
const defineCustomElement = defineCustomElement$1;

export { RocheBackToBranch, defineCustomElement };

//# sourceMappingURL=roche-back-to-branch.js.map